import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { PAGE_ERROR_I18N_COMPONENT_KEY } from "./constants";
var localesEs = /*#__PURE__*/_defineProperty({}, PAGE_ERROR_I18N_COMPONENT_KEY, {
  ALT_ERROR_IMAGE: 'Ilustración del error {{errorCode}}',
  TITLE_ERROR: 'Error',
  LABEL_ERROR_CODE: 'Código de error {{errorCode}}',
  LABEL_LOGO_CREHANA: 'Logo de Crehana',
  WHAT_WENT_WRONG: '¿Qué salió mal?',
  CTA_DEFAULT_TEXT: 'Ir al inicio',
  CTA_DEFAULT_TEXT_401: 'Iniciar sesión',
  NO_PERMISSIONS_401_TITLE: '¡Ups! no puedes acceder a esta sección',
  NO_PERMISSIONS_403_TITLE: '¡Lo sentimos! no podemos mostrarte la información',
  NO_PERMISSIONS_500_TITLE: '¡Ups! Esto no estaba en nuestros planes',
  CONTACT_ADMIN: 'Si el problema persiste, contacta al administrador de la cuenta. Mientras tanto puedes:',
  WHAT_HAPPENED_ERROR__401_DESCRIPTION: 'Parece que tu sesión caducó o que intentaste ingresar a una sección a la que no tienes acceso con esta cuenta. Por favor, inicia sesión nuevamente.',
  WHAT_HAPPENED_ERROR__403_DESCRIPTION: 'No tienes el rol y los permisos suficientes para acceder a esta información.',
  WHAT_HAPPENED_ERROR__500_DESCRIPTION: 'Encontramos un problema técnico. Estamos trabajando para solucionarlo lo más rápido posible.',
  LABEL_POWERED_BY_CREHANA: 'Powered by Crehana',
  TITLE_401: 'Tu sesión expiró',
  DESCRIPTION_401: 'o no pudimos confirmar tus credenciales de acceso'
});
export default localesEs;